import { ThemeBlueprint } from "@backstage/plugin-app-react";
import { UnifiedThemeProvider } from "@backstage/theme";
import { CssBaseline } from "@material-ui/core";
import LightIcon from '@material-ui/icons/WbSunny';
import { vaporTheme } from "../themes";

export const vaporThemeExtension = ThemeBlueprint.make({
  name: 'vapor-theme',
  params: {
    theme: {
      id: 'vapor-theme',
      title: 'Vapor theme',
      variant: 'light',
      icon: <LightIcon />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={vaporTheme} themeName='vapor'>
          <CssBaseline>{children}</CssBaseline>
        </UnifiedThemeProvider>
      ),
    },
  },
});